module.exports = __webpack_public_path__ + "static/tow-truck3-01b1cb16e637f7860c7e6f015ed5c694.jpg";